import React, { useCallback, useEffect, useRef, useState } from 'react';
import { api, apiError } from '../../api/client';
import { Button, FormField } from '../ui';

const EMPTY = { since: '', until: '', level: '', service: '', user_id: '', session_id: '', task_id: '', request_id: '', call_id: '', q: '' };
export default function LogsPanel() {
  const [draft, setDraft] = useState(EMPTY);
  const [filters, setFilters] = useState({});
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [live, setLive] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const revision = useRef(0);
  const load = useCallback(async (nextCursor = null) => {
    const version = ++revision.current;
    setBusy(true);
    try {
      const result = await api.getLogs({ ...filters, ...(nextCursor ? { cursor: nextCursor } : {}) });
      if (version !== revision.current) return;
      setItems(old => nextCursor ? [...old, ...result.items] : result.items);
      setCursor(result.cursor); setError('');
      setNotice(result.unavailable || (result.truncated ? 'Показана часть записей. Нажмите «Ещё» для продолжения.' : '') + (result.skipped_lines_or_files ? ` Пропущено строк или файлов: ${result.skipped_lines_or_files}.` : ''));
    } catch (e) { if (version === revision.current) setError(apiError(e)); }
    finally { if (version === revision.current) setBusy(false); }
  }, [filters]);
  useEffect(() => { load(); return () => { revision.current++; }; }, [load]);
  useEffect(() => { if (!live) return undefined; const timer = setInterval(() => load(), 5000); return () => clearInterval(timer); }, [live, load]);
  const fields = [['service', 'Сервис'], ['user_id', 'ID пользователя'], ['session_id', 'ID сессии'], ['task_id', 'ID задачи'], ['request_id', 'ID запроса'], ['call_id', 'ID вызова'], ['q', 'Поиск по событиям']];
  return <div>
    <p className="text-muted">По умолчанию — события за последние 24 часа. Время отображается в часовом поясе браузера.</p>
    <form onSubmit={e => { e.preventDefault(); setFilters(Object.fromEntries(Object.entries(draft).filter(([, v]) => v.trim()).map(([k, v]) => [k, k === 'since' || k === 'until' ? new Date(v).toISOString() : v]))); }}>
      <div className="flex gap-2" style={{ flexWrap: 'wrap', alignItems: 'end' }}>
        {[['since', 'Начало периода'], ['until', 'Конец периода']].map(([key, label]) => <FormField key={key} label={label}><input className="form-input" type="datetime-local" value={draft[key]} onChange={e => setDraft({ ...draft, [key]: e.target.value })} /></FormField>)}
        <FormField label="Уровень"><select className="form-input" value={draft.level} onChange={e => setDraft({ ...draft, level: e.target.value })}><option value="">Все уровни</option>{['DEBUG', 'INFO', 'WARNING', 'ERROR', 'CRITICAL'].map(v => <option key={v}>{v}</option>)}</select></FormField>
        {fields.map(([key, label]) => <FormField key={key} label={label}><input className="form-input" value={draft[key]} onChange={e => setDraft({ ...draft, [key]: e.target.value })} /></FormField>)}
        <Button className="btn btn-primary" type="submit">Найти</Button>
        <Button className="btn" type="button" disabled={busy} onClick={() => load()}>Обновить</Button>
      </div>
    </form>
    <label style={{ display: 'block', margin: '16px 0' }}><input type="checkbox" checked={live} onChange={e => setLive(e.target.checked)} /> Обновлять каждые 5 секунд</label>
    {error && <p className="alert alert-error" role="alert">{error}</p>}
    {notice && <p role="status">{notice}</p>}
    <div className="card">
      {!items.length && <p>{busy ? 'Загрузка…' : 'Подходящих событий нет.'}</p>}
      {items.map((event, i) => <details key={`${event.ts}-${i}`} style={{ borderBottom: '1px solid var(--border)', padding: '8px 0' }}>
        <summary style={{ overflowWrap: 'anywhere', cursor: 'pointer' }}>{new Date(event.ts).toLocaleString('ru-RU')} · {event.level} · {event.service} · {event.msg}</summary>
        <pre style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', fontSize: '0.8rem' }}>{JSON.stringify(event, null, 2)}</pre>
      </details>)}
      {cursor && <Button className="btn" disabled={busy} onClick={() => { setLive(false); load(cursor); }}>Ещё события</Button>}
    </div>
  </div>;
}
